export default __webpack_public_path__ + "static/media/bg.2df1ecf3.png";